import React from 'react';
import { GDPR_ID } from 'global-ids';
import { MESSAGE } from 'injection-classes';
import { Transition } from 'react-transition-group';

import { getAdminBarWidth } from 'services/admin/selectors';
import { GDPRAccepted } from 'services/modals';
import { getSidebarWidth } from 'services/user-layout/selectors';
import { useDispatch, useSelector } from 'react-redux';
import {
  AcceptButton,
  ButtonContainer,
  Container,
  RejectButton,
  StyledLink,
  StyledModalWindow,
  TextWrapper,
} from './styles';
import { useAdminTranslation } from 'hooks/use-translation';
import { GDPRRejected } from 'services/modals/actions';
import { PRIVACY_POLICY_URL } from 'shared/constants';

function GDPRModal() {
  const dispatch = useDispatch();
  const adminbarWidth = useSelector(getAdminBarWidth);
  const sidebarWidth = useSelector(getSidebarWidth);
  const { t } = useAdminTranslation();

  const handleAccept = () => {
    setTimeout(() => {
      dispatch(GDPRAccepted());
    }, 500);
  };

  const handleReject = () => {
    dispatch(GDPRRejected());
  };

  return (
    <StyledModalWindow adminbarWidth={adminbarWidth} sidebarWidth={sidebarWidth}>
      <Transition in={true} timeout={0}>
        {(state) => (
          <Container id={GDPR_ID} state={state}>
            <TextWrapper className={MESSAGE}>
              <span>
                {t('GDPR_PROMPT')}
                <StyledLink href={PRIVACY_POLICY_URL} target="_blank">
                  {t('GDPR_LINK')}
                </StyledLink>
              </span>
            </TextWrapper>
            <ButtonContainer>
              <RejectButton onClick={handleReject}>{t('ACTION_REJECT_TERMS')}</RejectButton>
              <AcceptButton onClick={handleAccept}>{t('ACTION_ACCEPT_TERMS')}</AcceptButton>
            </ButtonContainer>
          </Container>
        )}
      </Transition>
    </StyledModalWindow>
  );
}

export default GDPRModal;
